/* eslint no-restricted-syntax:0, no-restricted-globals:0, max-len:0, no-global-assign:0 */
import {
  webviewInfo, util
} from '@ali/amap-lib';
import actConfig from './config.act';
//* 接口名称
const AOS_NAME = actConfig.aosName;
const AOS_LINE = actConfig.aosLine;
let isPublic = webviewInfo.isPublic();
const host = window.location.hostname;
const legacyPreHost = 'h5-cms-test.oss-cn-hangzhou-zmf.aliyuncs.com';
const preHosts = ['pre-cache.amap.com'];
let isPreEnv = preHosts.includes(host)
  || (util.getUrlParam('pre') && host === legacyPreHost); // 是否预发环境
if (util.getUrlParam('env') === 'public') {
  isPublic = true;
  isPreEnv = false;
  console.log('检测到env=public，强制使用公网环境');
}
console.log(`%cAOSURL 是否强制使用预发环境-->>${isPreEnv}`, 'color: orange');

console.log(`%cAOSURL 是否强制使用预发环境-->>${isPreEnv}`, 'color: orange');

const isObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';
// nodejs 环境
if (
  typeof module !== 'undefined'
  && module.exports
  && typeof window === 'undefined'
) {
  location = {
    protocol: 'http:',
  };
}

const AOS_URL = Object.create(
  Object.create(null, {
    aosName: {
      value: AOS_NAME,
    },
  })
); // output
const AOS_PRE_DEV = `//sns.testing.amap.com/ws/${AOS_LINE}/`; //* 测试环境接口域名
const AOS_PRE_PRE = `//pre-sns.amap.com/ws/${AOS_LINE}/`; // 预发环境接口域名
const AOS_PRE_PUBLIC = `//sns.amap.com/ws/${AOS_LINE}/`; //* 正式环境接口域名

const AOS_URL_GROUP = {
  // push文章页
  detail: {
    test: '//oss.amap.com/ws/push_news/detail',
    pre: '//oss.amap.com/ws/push_news/detail',
    public: '//oss.amap.com/ws/push_news/detail'
  },
  // push文章页新版本（apiver=2）
  push_detail: {
    test: '//maps.testing.amap.com/ws/idc/lbp/push_news/push_detail',
    pre: '//pre-gateway.amap.com/ws/idc/lbp/push_news/push_detail',
    public: '//m5.amap.com/ws/idc/lbp/push_news/push_detail'
  },
  // push热门文章推荐
  articleList: {
    test: '//pre-gateway.amap.com/ws/msgbox/pull_notification_msgs',
    pre: '//pre-gateway.amap.com/ws/msgbox/pull_notification_msgs',
    public: '//m5.amap.com/ws/msgbox/pull_notification_msgs'
  },
  weather: {
    test: '//m5.amap.com/ws/shield/dsp/push/weather',
    public: '//m5.amap.com/ws/shield/dsp/push/weather'
  },
  // 交通开数据
  homePageList: {
    test: '//sns.amap.com/ws/activity/traffic/homepage/list',
    public: '//sns.amap.com/ws/activity/traffic/homepage/list'
  },
  // 实时拥堵列表
  congestList: {
    test: '//sns.amap.com/ws/activity/traffic/congest/list',
    public: '//sns.amap.com/ws/activity/traffic/congest/list'
  },
  /*
  运营活动通用接口
   */
  voucher: { // 提现问卷
    test: '//sns.testing.amap.com/ws/acs/activity_base/wallet/voucher',
    public: '//sns.amap.com/ws/acs/activity_base/wallet/voucher'
  },
  question_submit: { // 问卷提交
    test: '//sns.testing.amap.com/ws/acs/activity_base/wallet/voucher_submit',
    public: '//sns.amap.com/ws/acs/activity_base/wallet/voucher_submit'
  },
  owner_cash_to_wallet: { // 钱包提现
    test: '//sns.testing.amap.com/ws/acs/activity_base/wallet/withdraw-cash',
    public: '//sns.amap.com/ws/acs/activity_base/wallet/withdraw-cash'
  },
  address: { // 编辑地址
    test: '//sns.testing.amap.com/ws/acs/activity_base/owner/address-edit',
    public: '//sns.amap.com/ws/acs/activity_base/owner/address-edit'
  },
  // 分享文案及配置
  share_share_conf: {
    test: '//sns.testing.amap.com/ws/oss/activity_base/share/share-conf',
    public: '//sns.amap.com/ws/oss/activity_base/share/share-conf',
  },
  // 口令
  share_command: {
    test: '//sns.testing.amap.com/ws/oss/operation/share-code',
    public: '//sns.amap.com/ws/oss/operation/share-code'
  },
  // base64生成图片
  create_image: {
    test: '//sns.testing.amap.com/ws/oss/activity_base/create_image',
    public: '//sns.amap.com/ws/oss/activity_base/create_image',
  },
  // push落地领券 首页
  index: {
    test: '//sns.testing.amap.com/ws/activity/push_share/index',
    public: '//sns.amap.com/ws/activity/push_share/index',
  },
  // push落地领券 - 领券
  draw: {
    test: '//sns.testing.amap.com/ws/activity/push_share/draw',
    public: '//sns.amap.com/ws/activity/push_share/draw',
  }
};

const DEV_HOST = window.location.protocol + AOS_PRE_DEV + AOS_NAME;
const PRE_HOST = window.location.protocol + AOS_PRE_PRE + AOS_NAME;
const ONLINE_HOST = window.location.protocol + AOS_PRE_PUBLIC + AOS_NAME;

let HOST;
if (isPreEnv) {
  HOST = PRE_HOST;
} else if (isPublic) {
  HOST = ONLINE_HOST;
} else {
  HOST = DEV_HOST;
}

/**
 *
 * @param group
 */
const merge = (group) => {
  Object.keys(group).forEach((key) => {
    const groupItem = group[key];
    const isObjectType = isObject(groupItem);
    if (isObjectType) {
      if (isPreEnv) {
        // fallback to public
        AOS_URL[key] = window.location.protocol + (groupItem.pre || groupItem.public);
      } else if (isPublic) {
        AOS_URL[key] = window.location.protocol + groupItem.public;
      } else {
        AOS_URL[key] = window.location.protocol + groupItem.test;
      }
    } else {
      AOS_URL[key] = `${HOST}/${groupItem}`;
    }
  });
};

merge(AOS_URL_GROUP);

// eslint-disable-next-line no-underscore-dangle
AOS_URL._install = merge;

export default AOS_URL;
